<div class="toggle" [class.expanded]="expand" (click)="toggled()">
    <div [innerHTML]="message | msTrust: 'html'"></div>

    <vn-icon class="show-more-icon-alignment" slot="end" size="12" [name]="expand ? 'theme-up' : 'theme-down'"></vn-icon>
</div>
